// User setting storing whether the redaction storage warning dialog should be skipped
export const REDACT_WARNING_KEY = 'hide-redact-storage-warning'

// Reasons that block redaction
// but shouldn't be surfaced to the user as an actionable message
export const IGNORED_REDACTION_BLOCKED_REASONS = [
  'NOT_PM',
  'NOT_DATAROOM',
  'MISSING_SUBSCRIPTION_OPTION',
]
